const SYNTHESIA_EMBED_ORIGIN = "https://share.synthesia.io";
const SYNTHESIA_EMBED_PATH =
  /^\/embeds\/videos\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
// Synthesia's embed snippet includes a language selector, e.g. `?language=en`.
// Only that single parameter is allowed, so the stored URL carries no extra state.
const SYNTHESIA_LANGUAGE_QUERY = /^\?language=[A-Za-z]{2,3}(?:[-_][A-Za-z0-9]{2,8})*$/;
// Synthesia hands out a full <div><iframe src="..."></iframe></div> snippet.
const IFRAME_SRC_PATTERN = /<iframe\b[^>]*\bsrc\s*=\s*"([^"]+)"/i;

const isAllowedSynthesiaQuery = (search) =>
  !search || SYNTHESIA_LANGUAGE_QUERY.test(search);

export const normalizeSynthesiaEmbedUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;

  let candidate = value;
  if (candidate.includes("<")) {
    const match = candidate.match(IFRAME_SRC_PATTERN);
    if (!match) return null;
    candidate = match[1].trim();
  }

  if (candidate !== candidate.trim()) return null;

  try {
    const url = new URL(candidate);
    if (
      url.protocol !== "https:" ||
      url.origin !== SYNTHESIA_EMBED_ORIGIN ||
      url.port ||
      url.username ||
      url.password ||
      !isAllowedSynthesiaQuery(url.search) ||
      url.hash ||
      !SYNTHESIA_EMBED_PATH.test(url.pathname) ||
      url.href !== candidate
    ) {
      return null;
    }

    return url.href;
  } catch {
    return null;
  }
};
